var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeCoracao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 104,
    viewBox: "0 0 118 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_246_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8684 86.9862L53.4436 86.597L23.6732 59.0635C18.4566 54.2404 15.5 47.4713 15.5 40.3806V39.8222C15.5 27.9085 23.9961 17.6871 35.7547 15.4533C42.4496 14.1671 49.2975 15.7071 54.752 19.5317C56.2812 20.6147 57.7086 21.867 59 23.3055C59.7137 22.4932 60.4783 21.7486 61.2939 21.0547C61.9227 20.5132 62.5684 20.0055 63.248 19.5317C68.7025 15.7071 75.5504 14.1671 82.2453 15.4363C94.0039 17.6701 102.5 27.9085 102.5 39.8222V40.3806C102.5 47.4713 99.5434 54.2404 94.3268 59.0635L64.5564 86.597L64.1316 86.9862C62.7383 88.2723 60.9031 89 59 89C57.0969 89 55.2617 88.2892 53.8684 86.9862ZM56.1283 32.2915C56.0604 32.2407 56.0094 32.173 55.9584 32.1053L52.9338 28.7208L52.9168 28.7039C48.9916 24.3208 43.0613 22.3239 37.284 23.4239C29.3656 24.9301 23.6562 31.8007 23.6562 39.8222V40.3806C23.6562 45.2036 25.6783 49.8236 29.2297 53.1066L59 80.6401L88.7703 53.1066C92.3217 49.8236 94.3438 45.2036 94.3438 40.3806V39.8222C94.3438 31.8177 88.6344 24.9301 80.733 23.4239C74.9557 22.3239 69.0084 24.3378 65.1002 28.7039C65.1002 28.7039 65.1002 28.7039 65.0832 28.7208C65.0662 28.7377 65.0832 28.7208 65.0662 28.7377L62.0416 32.1223C61.9906 32.19 61.9227 32.2407 61.8717 32.3084C61.107 33.0699 60.0705 33.493 59 33.493C57.9295 33.493 56.893 33.0699 56.1283 32.3084V32.2915Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_246_642",
    x: 0.5,
    y: 0,
    width: 117,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.576471 0 0 0 0 0.0313726 0 0 0 0 0.0313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_642",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCoracao);
export default __webpack_public_path__ + "static/media/icone-coracao.bc5bb65d61c3724e8e9a760e2a6dae87.svg";
export { ForwardRef as ReactComponent };